// export const BASE_API_URL = "https://localhost:44370/api";
export const BASE_API_URL = "https://apiunique.sapeagleerp.com/api";

export const PROFILE_API = {
  GET_ALL: `${BASE_API_URL}/Profile`,
  GET_BY_ID: (id) => `${BASE_API_URL}/Profile/${id}`,
  GET_BY_VENDOR: (vendorId) => `${BASE_API_URL}/Product/vendor/${vendorId}`, 
  UPDATE: (id) => `${BASE_API_URL}/Profile/${id}`,
    VERIFY: (id) => `${BASE_API_URL}/Profile/verify/${id}`,
  BLOCK: (id) => `${BASE_API_URL}/Profile/block/${id}`,
  UNBLOCK: (id) => `${BASE_API_URL}/Profile/unblock/${id}`,
};

export const PRODUCT_API = {
  GET_ALL: `${BASE_API_URL}/Product`,
  GET_BY_ID: (id) => `${BASE_API_URL}/Product/${id}`,
  GET_BY_VENDOR: (vendorId) => `${BASE_API_URL}/Product/vendor/${vendorId}`,
  CREATE: `${BASE_API_URL}/Product/Create`,
  UPDATE: (id) => `${BASE_API_URL}/Product/update/${id}`,
  DELETE: (id) => `${BASE_API_URL}/Product/delete/${id}`,
    BULK_CREATE: `${BASE_API_URL}/Product/bulkcreate`,
};

export const RETURN_API = {
  REQUEST: (orderId) => `${BASE_API_URL}/Order/return/${orderId}`,
  GET_ALL_REQUESTS: `${BASE_API_URL}/Order/return-requests`
};

export const CATEGORY_API =        {
  GET_ALL: `${BASE_API_URL}/Category`,
  CREATE:`${BASE_API_URL}/Category/create`,
  GET_BY_ID: (id) => `${BASE_API_URL}/Category/${id}`
}


export const ORDER_API = {
  CREATE: `${BASE_API_URL}/Order/create`,
  GET_ALL: `${BASE_API_URL}/Order`,
  GET_BY_ID: (id) => `${BASE_API_URL}/Order/${id}`

}
export const PAYMENT_API = {
  GET_ALL: `${BASE_API_URL}/Payment/all`
}


export const WALLET_API = {
  GET_BALANCE: (userId) => `${BASE_API_URL}/Wallet/${userId}`,
  ADD: `${BASE_API_URL}/Wallet/add`,
  SPEND: `${BASE_API_URL}/Wallet/spend`,
  TRANSACTIONS: (userId) => `${BASE_API_URL}/Wallet/transactions/${userId}`
};
export const THEMES_ADMIN_API = {
  GET_THEMES : `${BASE_API_URL}/Theme`,
  POST : `${BASE_API_URL}/Theme`
}



export const SERVICE_REQUEST_API = {
  GET_ALL: `${BASE_API_URL}/ServiceRequests`,
  CREATE: `${BASE_API_URL}/ServiceRequests/create`,
  GET_BY_ID: (id) => `${BASE_API_URL}/ServiceRequests/${id}`,
};

export default PROFILE_API;
